<template>
    <v-slide-group
      v-model="model"
      class="pa-4"
      show-arrows
      max="0"
    >
      <template v-slot:prev>
        <v-btn
          elevation="3"
          icon
          large
          x-small
          style="pointer-events: auto !important;"
          :disabled="false"
          @click.native="goToNext('Prev')"
        >
          <v-icon>
            navigate_before
          </v-icon>
        </v-btn>
      </template>
      <v-slide-item
        v-for="(product, index) in this.eventDetails.Products"
        :key="index"
        v-slot="{ active, toggle }"
        class="my-1"
      >
        <v-card
          class="categoryCards rounded-lg mx-2"
          width="300"
          :elevation="active ? 8 : 1"
        >
          <v-img
            :src="product.PictureUrl"
            height="200px"
            class="d-flex align-start text--right"
          >
            <v-card dark class="d-inline-block ma-1 pa-1 primary">
              <h3>{{$translate('AMOUNT')}}: {{product.Quantity}}</h3>
            </v-card>
          </v-img>
          <div class="col-12 blue-grey--text text--darken-4 text-center font-weight-bold text-truncate">
            {{ product.Name }}
          </div>
        </v-card>
      </v-slide-item>
      <template v-slot:next>
        <v-btn
          elevation="3"
          icon
          large
          x-small
          style="pointer-events: auto !important;"
          :disabled="false"
          @click.native="goToNext('Next')"
        >
          <v-icon>
            navigate_next
          </v-icon>
        </v-btn>
      </template>
    </v-slide-group>
</template>

<script>
export default {
  name: 'EventDetailsProduct_AuctionProductList',
  components: {
  },
  props: {
    eventDetails: Object,
  },
  data() {
    return {
      model: 0,
      interval: {},
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
  },
  mounted() {
    const self = this;
    // because its called in a interval you cant use this
    this.interval = setInterval(() => {
      self.goToNext();
    }, 5000);
  },
  methods: {
    goToNext(button) {
      const startItem = 0;
      if (button === 'Next') {
        // check if model is not at the end
        if (this.model !== (this.eventDetails.Products.length - 1)) this.model++;
        // if model is at the end than set model to default
        else this.model = startItem;
      } else if(button === 'Prev'){
        // check if model is not at the start
        if (this.model !== startItem) this.model--;
        else {
          // set model to end
          const lastItem = this.eventDetails.Products.length - 1;
          this.model = lastItem;
        }
        // for the interval is this else
      } else this.model !== (this.eventDetails.Products.length - 1) ? this.model++ : this.model = startItem;
    },
  },
};
</script>

<style scoped>
</style>
